import styles from './styles.module.css'
import {
  DataGrid
} from '../../widgets/data-grid'
import { useCallback, useEffect, useRef, useState } from 'react'
import { PlayerManipulationService } from '../../shared/player/services/player-manipulation-service'
import { type TPlayer, type TPlayerDeleteMessage } from './types'
import { useNavigate } from 'react-router-dom'
import { redirectIfNoRefreshToken } from '../../shared/redirects'
import { columns, mapDispatchToProps, mapStateToProps } from './maps'
import { connect, useDispatch } from 'react-redux'
import { IconMenu } from '../../widgets/icon-menu'
import { SearchPanel } from '../../widgets/search-bar/SearchPanel'
import { type TSearchQuery } from '../../widgets/search-bar/types'
import { searchFilter } from '../../widgets/search-bar/search-service'
import { showErrorMessage, showInfoMessage, clearErrorMessage, clearInfoMessage } from 'app/store/slices/alerts'
import { clearEditablePlayer, setCountPlayers, setEditablePlayer } from 'app/store/slices/player'

const playerManipulationService = PlayerManipulationService()

export const PlayersListPage: any = connect(mapStateToProps, mapDispatchToProps)(function ({
  count,
  players,
  selectedPlayers,
  setPlayers,
  setSelectedPlayers
}: any) {
  const [errorMessage, setErrorMessage] = useState('')
  const [localPlayers, setLocalPlayers] = useState(players)
  const [searchQuery, setSearchQuery] = useState<TSearchQuery[]>([])
  const [selection, setSelection] = useState<any>([])
  const scrollPage = useRef<any>(null)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const scrollEnd = () => {
    if (!scrollPage) {
      return
    }
    const container = scrollPage.current;
    if (container) {
        container.scrollTop = container.scrollHeight; // Прокрутка вниз
    }
  }
  /**
     * @todo: Выполнить загрузку данных в редакс, с целью обхода множественного запроса всех данных
     */

  const loadWholePlayers = async () => {
    const players = await playerManipulationService.takeWholePlayers()
    if (players.errorMessage) {
      setErrorMessage(players.errorMessage); return
    }
    setPlayers(players.players || [])
  }

  useEffect(() => {
    setLocalPlayers(searchFilter(players, searchQuery))
  }, [searchQuery, players])

  useEffect(() => {
    redirectIfNoRefreshToken(navigate)
    // loadWholePlayers()
  }, [])

  const onEditObject = useCallback((newPlayerData: any) => {
    const newPlayers = [...players]
    newPlayers[newPlayerData.keyId] = {...newPlayers[newPlayerData.keyId], ...newPlayerData, initialRating: Number(newPlayerData.initialRating)}
    delete newPlayers[newPlayerData.keyId].keyId
    setPlayers(newPlayers)
  }, [players, setPlayers])

  function checkBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return true;
    } else {
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      var newBytes = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
      if (i > 0 && newBytes > 700) {
        setTimeout(() => { dispatch(clearErrorMessage()) }, 5000)
        dispatch(showErrorMessage(`Размер файла: ${newBytes + ' ' + sizes[i]}; больше допустимого: 700 КБ`));
        return false
      }
      return true;
    }
  }

  const onPlayerRowSave = useCallback(async (playersKey: number) => {
    const playerName = players[playersKey].name
    const playerСountry = players[playersKey].country

    const sizePhoto = new Blob([players[playersKey].avatar]).size
    if(!checkBytes(sizePhoto)) {
      return
    }

    const doubleSpaceCondition = /  /
    const reg = /^[A-Z]{2}$/

    if(!reg.test(playerСountry)){
      dispatch(showErrorMessage('Только двубуквенное обозначение большими латинскими буквами'));
      setTimeout(() => { dispatch(clearErrorMessage()) }, 5000)
      return
    }

    if(doubleSpaceCondition.test(playerName)){
      dispatch(showErrorMessage('В имени не должно быть двойных пробелов'));
      setTimeout(() => { dispatch(clearErrorMessage()) }, 5000)
      return
    }

    const { errorMessage, status }: any = await playerManipulationService.updatePlayer({...players[playersKey], name: playerName.trim()})

    if (errorMessage) {
      setTimeout(() => { setErrorMessage('') }, 5000)
      dispatch(showErrorMessage(errorMessage));
      setTimeout(() => { dispatch(clearErrorMessage()) }, 5000)
      return
    }

    dispatch(showInfoMessage(`Пользователь ${players[playersKey].id} успешно обновлен`));
    setTimeout(() => { dispatch(clearInfoMessage()) }, 5000)
    // await loadWholePlayers()
  }, [players])

  const onSearchQueryChange = useCallback(async (query: TSearchQuery[]) => {
    if (query[0].value !== '') {
      const {count} = await playerManipulationService.getCountPlayersField(query[0].field, query[0].value)
      dispatch(setCountPlayers(count))
      const {players} = await playerManipulationService.getPlayersField(query[0].field, query[0].value)
      dispatch(setPlayers(players || []))
    } else {
      const {count} = await playerManipulationService.getCountPlayers()
      dispatch(setCountPlayers(count))
    }
    setSearchQuery(query)
  }, [])

  const onSelectionChange = (selection: string[]) => { 
    return setSelection(selection)
    // return setSelectedPlayers(players?.filter((player: TPlayer) => selection.includes(player.id)) || []) 
  }

  const onRowDblClick = (playerId: any) => {
    if (!players) {
      return
    }
    const redPlayer = players.find((n: TPlayer) => n.id === playerId)
    dispatch(setEditablePlayer(redPlayer))
    navigate(`/players/create?regime=update&id=${playerId}`)
  }

  const onDeletePlayer = async (target: TPlayer) => {
    if(!target?.id){ 
      return
    }
    const confirmation = confirm(`Вы уверены, что хотите удалить игрока: ${target.name}`);
    if (!confirmation) {
      return
    }
    
    const playerDeleteMessage: TPlayerDeleteMessage = await playerManipulationService.removePlayer(target.id)
    if (playerDeleteMessage.errorMessage) {
        setTimeout(() => { setErrorMessage('') }, 5000)
        dispatch(showErrorMessage(playerDeleteMessage.errorMessage));
        setTimeout(() => dispatch(clearErrorMessage()), 5000)
        return
    }
    dispatch(showInfoMessage(`Игрок ${target.id} удален`))
    setTimeout(() => dispatch(clearInfoMessage()), 5000)
  }

  const onCreateClick = () => {
    dispatch(clearEditablePlayer())
    navigate('/players/create')
  }

  const nextRows = async (page: number, perPageCount: number) => {
    if (searchQuery.length !== 0 && searchQuery[0].value !== '') {
      return players.slice(perPageCount * page, (perPageCount * page) + perPageCount)
    }
    
    const newPlayers = (await playerManipulationService.getPlayers(page, perPageCount))?.players
    setPlayers(newPlayers)
    return newPlayers
  }

  return <div ref={scrollPage} className={styles.PlayerPage}>
    {/* <AdminMenu /> */}
    <div className={styles.ListContainer}>
      <div className={styles.TableContainer}>
        <IconMenu
          onCreateClick={onCreateClick}
        />
        <SearchPanel
          columns={columns.filter(col => col.field !== 'avatar' && col.field !== 'birthDate')}
          onQueryChange={onSearchQueryChange}
        />
        <DataGrid
          onChange={() => {}} 
          nextRows={nextRows}
          rows={localPlayers}
          count={count}
          columns={columns}
          onRowChange={(row: any[]) => { onEditObject(row) }}
          onRowSave={onPlayerRowSave}
          onSelectionChange={onSelectionChange}
          onRowDelete={onDeletePlayer}
          controls={true}
          onRowDblClick={onRowDblClick}
        />
      </div>
    </div>
  </div>
})
